/**
 * Status of a product at a given site.
 */
export type AvailabilityStatus =
  | 'DISABLED'
  | 'READY_FOR_PRICING'
  | 'ENABLED'
  | 'DISCONTINUED';

export const AvailabilityStatus = {
  Disabled: 'DISABLED' as AvailabilityStatus,
  ReadyForPricing: 'READY_FOR_PRICING' as AvailabilityStatus,
  Enabled: 'ENABLED' as AvailabilityStatus,
  Discontinued: 'DISCONTINUED' as AvailabilityStatus,
};
